



























import { Component, Vue } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
import moment from "moment";
import { TYPES_MESSAGES } from "@/resources/constants/messages";
@Component({
  name: "paper-plane-message-component",
})
export default class PaperPlaneMessageComponent extends Vue {
  message = "";
  loading = false;
  get active(): boolean {
    return this.$store.getters["SystemStore/getOpenPaperPlaneModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setOpenPaperPlaneModalAction", e);
  }
  mounted() {
    document.getElementById("textarea").focus();
  }
  sendMessage() {
    const data = {
      message: this.message,
      type: "THROW_PAPER_PLANE",
      color: "BLUE",
      sound: "NO_SOUND",
      hasConfirmation: false,
      spaceUsers: [
        { id: this.$store.getters["SystemStore/getUserPaperPlaneId"] },
      ],
    };
    this.loading = true;
    this.$store.dispatch("SpaceStore/sendConsoleMessageAction", {
      spaceId: this.$store.getters["SpaceStore/getSpace"].id,
      data,
      callback: () => {
        this.$store.dispatch("ChatStore/sendNewMessageAction", {
          userId:
            this.$store.getters["SystemStore/getSuperSpaceUserPaperPlaneId"],
          data: {
            chatMessage: this.message,
            chatMessageType: TYPES_MESSAGES.PAPER_PLANE,
          },
        });
        this.message = "";
        this.loading = false;
        const localUser = this.$store.getters["UserStore/getSpaceUser"];
        const receiveUser = this.$store.getters[
          "SpaceStore/getUsersInDraw"
        ].filter(
          (a) => a.id === this.$store.getters["SystemStore/getUserPaperPlaneId"]
        )[0];
        this.$store.dispatch("GraphicClientStore/sendPaperPlaneAction", {
          sendId: localUser.superSpaceUser.user.id,
          receiveId: receiveUser.superSpaceUser.user.id,
        });
        this.$store?.dispatch(
          "SystemStore/setSuperSpaceUserPaperPlaneIdAction",
          0
        );
        this.$store.dispatch("SystemStore/setUserPaperPlaneIdAction", 0);
        this.$store.dispatch("SystemStore/setOpenPaperPlaneModalAction", false);
        const audio = new Audio(require("@/assets/audio/goofy.mp3"));
        audio.autoplay = true;
        audio.play();
        this.$vs.notification({
          icon: '<i class="fas fa-paper-plane" style="color: #2b3d8e"></i>',
          border: "primary",
          duration: 4000,
          clickClose: true,
          title: i18n.t("notifications.sendNewPaperPlane"),
          text: `<p style="text-align: end;font-size: 10px">${i18n.t(
            "labels.sentAt"
          )} ${moment().format("HH:mm")}</p>`,
          onDestroy: () => {
            audio.pause();
          },
        });
      },
    });
  }
}
